import { createElement as _createElement } from "react";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Callout, Collapsible, Divider, Dropdown, getTestId, isValidObject, StateConfigContext } from '@airtel/air-design-system';
import { debounce, merge } from 'lodash';
import { useCallback, useContext, useEffect, useMemo, useReducer, useState } from 'react';
import { Keyboard, View } from 'react-native';
import { LinkListItemWidget } from '../../../link-list-item-widget';
import { getSkycFormWidgetStyles } from '../../SkycFormWidgetStyles';
import { SimOwnerDetails } from './sim-owner-details';
import { SimProviderDetailsForm } from './sim-provider-details-form';
import { simDeclarationConfig, validatedAvatarConfig } from './SimDeclarationConfig';
import { getSimDeclarationStyles } from './SimDeclarationStyles';
import { checkAllConditionTrue, checkAnyConditionTrue, checkIfAnyProviderCountIsNull, generateDropdownDataWithNumber, getTotalSelectedSimCount, numberOfUnSelectedProviders } from './SimDeclarationUtils';
var getInitialProviderState = () => [{
  id: Math.random().toString(),
  provider: '',
  count: null
}];
var simOwnerDetailsInitialState = [];
export var SimDeclaration = props => {
  var _a;
  var _useContext = useContext(StateConfigContext),
    theme = _useContext.theme;
  var _useMemo = useMemo(() => merge({}, simDeclarationConfig, props), [simDeclarationConfig, props]),
    _state = _useMemo.state,
    successStateHeading = _useMemo.successStateHeading,
    isExpanded = _useMemo.isExpanded,
    disableToggle = _useMemo.disableToggle,
    autoFormSubmitDebounceDelay = _useMemo.autoFormSubmitDebounceDelay,
    isAutoFormSubmitDebounceAllowed = _useMemo.isAutoFormSubmitDebounceAllowed,
    calloutProps = _useMemo.calloutProps,
    style = _useMemo.style,
    onUserAction = _useMemo.onUserAction,
    id = _useMemo.id,
    onValidFormMetaData = _useMemo.onValidFormMetaData,
    onInValidFormMetaData = _useMemo.onInValidFormMetaData,
    onStepDetailsListItemPressMetaData = _useMemo.onStepDetailsListItemPressMetaData,
    onStepDetailsCtaPressMetaData = _useMemo.onStepDetailsCtaPressMetaData,
    inputsDataProps = _useMemo.inputsDataProps,
    dropdownsDataProps = _useMemo.dropdownsDataProps,
    stepDetailsProps = _useMemo.stepDetailsProps,
    maxNumberOfConnectionsAllowed = _useMemo.maxNumberOfConnectionsAllowed,
    isSimOwnerRequired = _useMemo.isSimOwnerRequired,
    testID = _useMemo.testID,
    variant = _useMemo.variant;
  var numberOfConnections = dropdownsDataProps.numberOfConnections,
    reasonDropdown = dropdownsDataProps.reasonDropdown,
    providerName = dropdownsDataProps.providerName;
  var _useState = useState(numberOfConnections),
    noOfConnectionsState = _useState[0],
    setNoOfConnectionsState = _useState[1];
  var _useState2 = useState(reasonDropdown),
    reasonDropdownState = _useState2[0],
    setReasonDropdownState = _useState2[1];
  var _useState3 = useState(_state),
    stateType = _useState3[0],
    setStateType = _useState3[1];
  var _useState4 = useState(isExpanded),
    isExpandedState = _useState4[0],
    setIsExpandedState = _useState4[1];
  var _useState5 = useState((_a = stepDetailsProps === null || stepDetailsProps === void 0 ? void 0 : stepDetailsProps.subHeading) !== null && _a !== void 0 ? _a : ''),
    subHeading = _useState5[0],
    setSubHeading = _useState5[1];
  var _useState6 = useState(null),
    selectedTotalConnectionCount = _useState6[0],
    setSelectedTotalConnectionCount = _useState6[1];
  var _useState7 = useState(''),
    multipleConnectionReason = _useState7[0],
    setMultipleConnectionReason = _useState7[1];
  useEffect(() => {
    setNoOfConnectionsState(prev => Object.assign(Object.assign({}, prev), numberOfConnections));
  }, [JSON.stringify(numberOfConnections)]);
  useEffect(() => {
    setReasonDropdownState(prev => Object.assign(Object.assign({}, prev), reasonDropdown));
  }, [JSON.stringify(reasonDropdown)]);
  var providerDetailsReducer = (state, action) => {
    var initialState = getInitialProviderState();
    switch (action.type) {
      case 'ADD_PROVIDER_DETAILS':
        return [...state, initialState[0]];
      case 'UPDATE_PROVIDER_DETAILS':
        {
          var _id = action.id,
            key = action.key,
            value = action.value;
          var countSum = 0;
          var updatedState = state.map(providerState => {
            var updatedProvider = providerState.id === _id ? Object.assign(Object.assign({}, providerState), {
              [key]: value
            }) : providerState;
            countSum += updatedProvider.count || 0;
            return updatedProvider;
          });
          if (countSum >= selectedTotalConnectionCount) {
            countSum = 0;
            return updatedState.filter(provider => {
              countSum += provider.count || 0;
              return countSum <= selectedTotalConnectionCount && provider.count !== null;
            });
          }
          return updatedState;
        }
      case 'REMOVE_ALL_PROVIDER_DETAILS':
        return initialState;
      default:
        return state;
    }
  };
  var _useReducer = useReducer(providerDetailsReducer, getInitialProviderState()),
    providerDetails = _useReducer[0],
    dispatchProviderDetails = _useReducer[1];
  var simOwnerDetailsReducer = (state, action) => {
    switch (action.type) {
      case 'UPDATE_SIM_DETAILS':
        return state.map(item => {
          var id = action.id,
            key = action.key,
            value = action.value;
          if (item.id === id) {
            return Object.assign(Object.assign({}, item), {
              [key]: value
            });
          }
          return item;
        });
      case 'REMOVE_ALL_SIM_DETAILS':
        return Array.from({
          length: selectedTotalConnectionCount
        }, () => ({
          id: Math.random().toString(),
          ownerName: '',
          mobileNumber: '',
          relationship: '',
          simProvider: ''
        }));
      default:
        return state;
    }
  };
  var _useReducer2 = useReducer(simOwnerDetailsReducer, simOwnerDetailsInitialState),
    simOwnerDetails = _useReducer2[0],
    dispatchSimOwnerDetails = _useReducer2[1];
  var skycFormWidgetStyle = getSkycFormWidgetStyles();
  var simDeclarationStyles = getSimDeclarationStyles();
  var isDisabledState = stateType === 'disabled';
  var isSuccessState = stateType === 'success';
  var handleSimOwnerDetailsChange = (id, key, value) => {
    dispatchSimOwnerDetails({
      type: 'UPDATE_SIM_DETAILS',
      id,
      key,
      value
    });
  };
  var handleTotalConnectionSelection = (_, __, data) => {
    var selectedCount = parseInt(data === null || data === void 0 ? void 0 : data.value);
    setSelectedTotalConnectionCount(selectedCount);
    dispatchProviderDetails({
      type: 'REMOVE_ALL_PROVIDER_DETAILS'
    });
    dispatchSimOwnerDetails({
      type: 'REMOVE_ALL_SIM_DETAILS'
    });
    var onChangeMetaData = noOfConnectionsState === null || noOfConnectionsState === void 0 ? void 0 : noOfConnectionsState.onChangeMetaData;
    isValidObject(onChangeMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, onChangeMetaData), {
      value: selectedCount
    }));
  };
  var handleAddProviderButtonPress = () => {
    dispatchProviderDetails({
      type: 'ADD_PROVIDER_DETAILS'
    });
  };
  var updateProviderDetails = (id, key, value) => {
    dispatchProviderDetails({
      type: 'UPDATE_PROVIDER_DETAILS',
      key,
      value,
      id
    });
  };
  var isConnectionSelected = !!selectedTotalConnectionCount && selectedTotalConnectionCount > 0;
  var showAddProviderButton = isConnectionSelected && getTotalSelectedSimCount(providerDetails, isConnectionSelected ? -1 : 0) < selectedTotalConnectionCount && !checkIfAnyProviderCountIsNull(providerDetails) && !!numberOfUnSelectedProviders(providerName, providerDetails);
  var validateSimOwnerDetails = () => {
    var _a, _b;
    if (!simOwnerDetails.length) return false;
    var mobileNumberRegex = new RegExp(((_a = inputsDataProps === null || inputsDataProps === void 0 ? void 0 : inputsDataProps.mobileNumber) === null || _a === void 0 ? void 0 : _a.validationRegex) || '');
    var ownerNameRegex = new RegExp(((_b = inputsDataProps === null || inputsDataProps === void 0 ? void 0 : inputsDataProps.ownerName) === null || _b === void 0 ? void 0 : _b.validationRegex) || '');
    return simOwnerDetails.every(simDetail => {
      var _a;
      var ownerName = simDetail.ownerName,
        mobileNumber = simDetail.mobileNumber,
        relationship = simDetail.relationship,
        simProvider = simDetail.simProvider;
      var isMobileNumberValid = mobileNumberRegex.test(mobileNumber);
      var isOwnerNameRegexValid = ownerNameRegex.test(ownerName);
      return checkAllConditionTrue(((_a = ownerName === null || ownerName === void 0 ? void 0 : ownerName.trim()) === null || _a === void 0 ? void 0 : _a.length) >= 3 && isOwnerNameRegexValid, isMobileNumberValid, relationship !== '', simProvider !== '');
    });
  };
  var validateProviderDetails = () => {
    if (!providerDetails.length) return false;
    return providerDetails.every(providerDetail => {
      var provider = providerDetail.provider,
        count = providerDetail.count;
      return provider !== '' && count !== null && count !== 0;
    });
  };
  var debouncedUserAction = useCallback(debounce(onUserAction, autoFormSubmitDebounceDelay), []);
  useEffect(() => {
    setStateType(_state);
    setIsExpandedState(_state === 'none');
  }, [_state]);
  useEffect(() => {
    setIsExpandedState(isExpanded);
    if (!isExpanded) Keyboard.dismiss();
  }, [isExpanded]);
  useEffect(() => {
    setSubHeading(prevSubHeading => (stepDetailsProps === null || stepDetailsProps === void 0 ? void 0 : stepDetailsProps.subHeading) || prevSubHeading);
  }, [stepDetailsProps === null || stepDetailsProps === void 0 ? void 0 : stepDetailsProps.subHeading]);
  useEffect(() => {
    if (isConnectionSelected) {
      var isProviderTotalCountMatched = getTotalSelectedSimCount(providerDetails, isConnectionSelected ? -1 : 0) === selectedTotalConnectionCount;
      var isProviderDetailsValid = validateProviderDetails() && isProviderTotalCountMatched;
      var metaData = isProviderDetailsValid ? onValidFormMetaData : onInValidFormMetaData;
      var providerSubHeading = providerDetails === null || providerDetails === void 0 ? void 0 : providerDetails.reduce((acc, provider) => {
        return "" + (acc ? acc + " &#8226; " : '') + (provider === null || provider === void 0 ? void 0 : provider.provider) + " " + (provider === null || provider === void 0 ? void 0 : provider.count);
      }, '');
      var providerDetailsText = providerDetails === null || providerDetails === void 0 ? void 0 : providerDetails.reduce((acc, provider) => {
        return "" + (acc ? acc + ", " : '') + (provider === null || provider === void 0 ? void 0 : provider.provider) + " " + (provider === null || provider === void 0 ? void 0 : provider.count);
      }, '');
      var userActionPayload = [Object.assign({
        id
      }, metaData), {
        props,
        providerDetails,
        selectedTotalConnectionCount,
        providerDetailsText
      }];
      setSubHeading(providerSubHeading);
      if (isAutoFormSubmitDebounceAllowed) {
        debouncedUserAction(...userActionPayload);
      } else {
        onUserAction(...userActionPayload);
      }
    }
  }, [providerDetails, selectedTotalConnectionCount]);
  useEffect(() => {
    if (isConnectionSelected) {
      var isSimOwnerDetailsValid = validateSimOwnerDetails();
      var isReasonDropdownValid = multipleConnectionReason !== '';
      var metaData = isSimOwnerDetailsValid && isReasonDropdownValid ? onValidFormMetaData : onInValidFormMetaData;
      if (!isValidObject(metaData)) return;
      var simOwnerDetailsSubHeading = simOwnerDetails === null || simOwnerDetails === void 0 ? void 0 : simOwnerDetails.reduce((acc, simOwner) => {
        return acc + " &#8226; " + simOwner.ownerName + " &#8226; " + simOwner.mobileNumber + " &#8226; " + simOwner.relationship + " &#8226; " + simOwner.simProvider;
      }, selectedTotalConnectionCount === null || selectedTotalConnectionCount === void 0 ? void 0 : selectedTotalConnectionCount.toString());
      var userActionPayload = [Object.assign({
        id
      }, metaData), {
        props,
        simOwnerDetails,
        multipleConnectionReason,
        selectedTotalConnectionCount
      }];
      setSubHeading(simOwnerDetailsSubHeading);
      if (isAutoFormSubmitDebounceAllowed) {
        debouncedUserAction(...userActionPayload);
      } else {
        onUserAction(...userActionPayload);
      }
    }
  }, [simOwnerDetails, multipleConnectionReason, selectedTotalConnectionCount]);
  useEffect(() => {
    var metaData = selectedTotalConnectionCount === 0 ? onValidFormMetaData : onInValidFormMetaData;
    var userActionPayload = [Object.assign({
      id
    }, metaData), {
      props,
      selectedTotalConnectionCount
    }];
    setSubHeading(selectedTotalConnectionCount === null || selectedTotalConnectionCount === void 0 ? void 0 : selectedTotalConnectionCount.toString());
    if (isAutoFormSubmitDebounceAllowed) {
      debouncedUserAction(...userActionPayload);
    } else {
      onUserAction(...userActionPayload);
    }
  }, [selectedTotalConnectionCount]);
  var handleChangeButtonPress = () => {
    setIsExpandedState(true);
  };
  var getTitleComponent = () => {
    return _jsx(LinkListItemWidget, Object.assign({}, stepDetailsProps, isSuccessState && !isExpandedState && successStateHeading && {
      heading: successStateHeading
    }, {
      noHoverEffect: true,
      theme: theme,
      noPressEffect: true,
      onUserAction: onUserAction,
      onPress: onStepDetailsListItemPressMetaData,
      actionTypeProps: !isExpandedState && !isDisabledState && (stepDetailsProps === null || stepDetailsProps === void 0 ? void 0 : stepDetailsProps.actionTypeProps),
      disabled: checkAnyConditionTrue(isDisabledState, stepDetailsProps === null || stepDetailsProps === void 0 ? void 0 : stepDetailsProps.disabled),
      actionTypeOnPressMetaData: onStepDetailsCtaPressMetaData,
      actionTypeOnPress: handleChangeButtonPress,
      subHeadingNumberOfLines: (stepDetailsProps === null || stepDetailsProps === void 0 ? void 0 : stepDetailsProps.subHeadingNumberOfLines) || 1
    }, isSuccessState && Object.assign({}, validatedAvatarConfig), isSuccessState && !isExpandedState && {
      subHeading
    }));
  };
  return isValidObject(stepDetailsProps) && _jsx(Collapsible, Object.assign({
    theme: theme,
    childPaddingToken: "SPACING_0",
    titleNoHorizontalPadding: true,
    showIcon: false,
    disabled: checkAnyConditionTrue(isDisabledState, disableToggle),
    titleNoVerticalPadding: true,
    isExpanded: isExpandedState,
    style: [skycFormWidgetStyle.heading, style],
    removeOverflow: true,
    titleComponent: getTitleComponent(),
    withCard: true
  }, getTestId(testID, variant + "_collapsible"), {
    children: _jsxs(View, Object.assign({
      style: skycFormWidgetStyle.content
    }, getTestId(testID, variant + "_content"), {
      children: [isValidObject(calloutProps) && _jsx(Callout, Object.assign({}, calloutProps, {
        theme: theme,
        style: skycFormWidgetStyle.calloutWidget
      }, getTestId(testID, variant + "_callout"))), _jsx(Dropdown, Object.assign({}, noOfConnectionsState, {
        theme: theme,
        dropdownList: generateDropdownDataWithNumber(maxNumberOfConnectionsAllowed + 1),
        onSelectedHandler: handleTotalConnectionSelection,
        style: [isConnectionSelected && simDeclarationStyles.connectionsCountInput, noOfConnectionsState.style],
        clearInputOnBlur: true,
        position: "below",
        listMaxHeightPercentage: 30,
        onInputClear: () => setSelectedTotalConnectionCount(null)
      }, getTestId(testID, variant + "_connections_dropdown"))), isConnectionSelected && !isSimOwnerRequired && _jsx(SimProviderDetailsForm, Object.assign({}, props, {
        providerDetails: providerDetails,
        isConnectionSelected: isConnectionSelected,
        selectedTotalConnectionCount: selectedTotalConnectionCount,
        showAddProviderButton: showAddProviderButton,
        handleAddProviderButtonPress: handleAddProviderButtonPress,
        updateProviderDetails: updateProviderDetails
      }, getTestId(testID, variant + "_provider_details_form"))), isConnectionSelected && isSimOwnerRequired && _jsxs(_Fragment, {
        children: [_jsx(Divider, {
          style: simDeclarationStyles.simOwnerDetailsTopDivider
        }), simOwnerDetails.map((simOwnerDetails, index) => (_createElement(SimOwnerDetails, Object.assign({}, props, {
          id: simOwnerDetails.id,
          index: index,
          key: simOwnerDetails.id.toString(),
          theme: theme,
          inputsDataProps: inputsDataProps,
          dropdownProps: dropdownsDataProps,
          title: "SIM " + (index + 1) + " details",
          onChange: handleSimOwnerDetailsChange
        }, getTestId(testID, variant + "_sim_owner_details_" + index))))), _jsx(Divider, {
          style: simDeclarationStyles.simOwnerDetailsBottomDivider
        }), _jsx(View, Object.assign({
          style: simDeclarationStyles.reasonDropdown
        }, {
          children: _jsx(Dropdown, Object.assign({}, reasonDropdownState, {
            theme: theme,
            style: reasonDropdownState.style,
            onSelectedHandler: (_, __, data) => {
              var _a;
              setMultipleConnectionReason(data === null || data === void 0 ? void 0 : data.value);
              var onChangeMetaData = reasonDropdownState === null || reasonDropdownState === void 0 ? void 0 : reasonDropdownState.onChangeMetaData;
              isValidObject(onChangeMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
                id
              }, onChangeMetaData), {
                value: (_a = data === null || data === void 0 ? void 0 : data[0]) === null || _a === void 0 ? void 0 : _a.value
              }));
            },
            clearInputOnBlur: true,
            onInputClear: () => setMultipleConnectionReason(''),
            position: "below",
            listMaxHeightPercentage: 30
          }, getTestId(testID, variant + "_reason_dropdown")))
        }))]
      })]
    }))
  }));
};